import React from 'react';
import { IQuestionElementProps } from '../../interface';
import { UmuInput } from '@umu/umu-design';
import { lang } from '@umu/ukit-lang';
import { QuestionOperateType, VIEW_MODE } from '../../../../interface/multiCapabilityTemplate';

import { AdvanceOption, IAdvanceOptionInfo } from '../radioOptionInfo/advanceOption';
const { Textarea } = UmuInput;

const TextQuestion = (props: IQuestionElementProps) => {
    const { preCls = 'template-question', info, mode } = props;
    const onValueInfoChange = (data: any) => {
        const dataValue = data?.value || '';
        const list = dataValue.split('\r\n').map((item: string, index: number) => ({
            index,
            id: '',
            desc: '',
            weights: 0,
            type: 0,
            title: item,
        }));
        props.onCommunication(QuestionOperateType.CHANGE_CONFIG, {
            ...props.info,
            list,
        });
    };
    const isView = mode === VIEW_MODE.VIEW;
    const onAdvanceChange = (data: IAdvanceOptionInfo) => {
        const extend = props.info?.extend;
        const setup = {
            require: '0',
            limit_options_min: '',
            limit_options_max: '',
        };
        setup.require = data.isRequire;
        setup.limit_options_min = String(data.range[0]);
        setup.limit_options_max = String(data.range[1]);
        props.onCommunication(QuestionOperateType.CHANGE_CONFIG, {
            ...props.info,
            extend: { ...extend, setup: { ...extend?.setup, ...setup } },
        });
    };
    const renderAdvanceContent = () => {
        const setup: any = info?.extend?.setup || {};
        const advanceInfo: any = {
            isRequire: String(setup?.require || 0),
            range: [setup?.limit_options_min || 0, setup?.limit_options_max || 0],
            optionCount: 0,
        };
        return <AdvanceOption isView={isView} multiple={false} info={advanceInfo} onChange={onAdvanceChange} />;
    };
    const value = (info?.list || []).map((item) => item.title).join('\r\n');
    return (
        <div className={`${preCls}-text-info ${isView ? 'view' : 'editor'}`}>
            <Textarea
                value={value}
                onChange={onValueInfoChange}
                expandConfig={{ minLength: 5, maxLength: 10, placeholder: lang('请输入提示内容'), disabled: isView }}
            ></Textarea>
            <div className={`${preCls}-option-advance`}>{renderAdvanceContent()}</div>
        </div>
    );
};
export { TextQuestion };
